'use client';

import { useState, useEffect } from 'react';
import { Login } from './components/pages/Login';
import { Hub } from './components/pages/Hub';
import { UsersPage } from './components/pages/UsersPage';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  const [token, setToken] = useState<string | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [page, setPage] = useState<'hub' | 'users'>('hub');

  useEffect(() => {
    const stored = localStorage.getItem('access_token');
    setToken(stored);
    if (stored) {
      fetch('/api/me', { headers: { Authorization: `Bearer ${stored}` } })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          if (d) setIsAdmin(!!d.is_admin);
        })
        .catch(() => {});
    }
  }, []);

  const handleLogin = (newToken: string) => {
    localStorage.setItem('access_token', newToken);
    setToken(newToken);
    fetch('/api/me', { headers: { Authorization: `Bearer ${newToken}` } })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d) setIsAdmin(!!d.is_admin);
      })
      .catch(() => {});
  };

  const handleLogout = async () => {
    try {
      await fetch('/api/logout', { method: 'POST' });
    } catch (e) {
      console.error('Logout failed:', e);
    }
    
    localStorage.removeItem('access_token');
    setToken(null);
    setIsAdmin(false);
    setPage('hub');
  };

  if (!token) return <Login onLogin={handleLogin} />;
  if (page === 'users') return <UsersPage token={token} onBack={() => setPage('hub')} onLogout={handleLogout} />;
  return <Hub onLogout={handleLogout} token={token} isAdmin={isAdmin} onNavigateUsers={() => setPage('users')} />;
}

export default function AppWrapper() {
  return (
    <LanguageProvider>
      <App />
    </LanguageProvider>
  );
}
